import { useRef } from 'react'
import SecondaryButton from 'components/Buttons/SecondaryButton'

export default function FileInput ({
  label = 'Selecionar arquivo',
  accept,
  onFileSelected: handleFileSelected
}) {
  const hiddenFileInput = useRef (null)
  
  const handleClick = event => {
    hiddenFileInput.current.click ()
  }

  const handleChange = event => {
    const fileUploaded = event.target.files[0]
    handleFileSelected (fileUploaded)
  }

  return (
    <>
      <SecondaryButton
        label={label}
        onClick={handleClick}
        width={180}
      />
      <input
        type='file'
        accept={accept}
        ref={hiddenFileInput}
        onChange={handleChange}
        style={{display: 'none'}}
      />
    </>
  )
}
